import useHostGlobals from 'appHost/Globals';
import { useMemo } from 'react';

export const useGlobal = () => {
  const global = useHostGlobals();

  return useMemo(
    () => ({ user: global.user, features: global.features, amplitude: global.amplitude }),
    [global.user, global.features, global.amplitude]
  );
};
